export default __webpack_public_path__ + "static/media/financial-advisor-man-3x.c4a3d3fa.png";